import React from "react";
import Spinner from "../../Components/Spinner";
import { useLanguage } from "../../Translations/LenguageContext";
import { Modal } from "react-bootstrap";

const InfoModal = ({ show, handleClose }) => {
    const { t } = useLanguage()

    return (
        <Modal show={show} onHide={handleClose} className="modal_share">
            <div className="share_main_cont_modal fade-in">
                <p className="share_label">{t.shared_space.shared_title}</p>
                <div className="share_link_cont_modal_share">
                    <p className="qa_p">{t.shared_space.shared_desc}</p>
                </div>
            </div>
            <div className="modal_footer_share fade-in">
                <div className="footer_btn_cont">
                    <button className="cancel_btn" onClick={handleClose}>{t.cancel}</button>
                </div>
            </div>
        </Modal>
    )
}

export default InfoModal